import { useMemo } from "react";

export default function useColumns() {
  const columns = useMemo(
    () => [
      {
        Header: "Nombre",
        accessor: "APPOINTMENT_NAME"
      },
      {
        Header: "Area",
        accessor: "AREA"
      },
      {
        Header: "Acciones",
        accessor: "acciones"
      }
    ],
    []
  );

  return columns;
}
